<div class="block-wrapper" *ngIf="blocksConfig.editable || !blocksConfig.submittable">
  <div class="w-100 page-break-wrapper d-print-none">
    <div class="page-break-marker"></div>
    <div class="page-break-label mx-2 small text-muted">Page Break</div>
    <div class="page-break-marker"></div>
  </div>
</div>
